import React from "react";
import SpecialitiesBanner from "../../../components/Banners/Speacialities-Banner/speacialities-banner";
import styles from "../specialities.module.css";
import ImageWithText from "../../../components/ImageWithText/ImageWithText";
import SpecialityFeatures from "../../../components/SpecialityFeatures/specialityFeatures";
import TextOnly from "../../../components/TextOnly/textOnly";
import MetaTags from "../../../components/MetaTags";
const PaymentGatewaysMgt = () => {
  const bannerContent = {
    heading: "Payment Gateways Management",
    subText: (
      <>
        At Ninjas Code, we understand that{" "}
       secure payment integrationand reliable{" "}
        payment processing are the backbone of any
        delivery-based business. Our Payment Gateway Solutions{" "}
        ensure users enjoy a smooth experience when placing orders and checking
        out.
      </>
    ),
  };

  const specialityAbout = [
    {
      aboutImage: {
        url: "assets//Speciality-Images/flexible-integration.webp",
        alt: "Flexible Integration",
      },
      aboutTitle: { title: `Flexible Integrations`, highlightedTitle: "" },
      aboutDescription: (
        <>
          Whether you require integration with local or global{" "}
         payment solutions, our team customizes services to
          match your business needs. From{" "}
          Stripe Integration Services to Hyp and other{" "}
          global payment gateways, we handle it all.
        </>
      ),
      flexReverse: "true",
    },
    {
      aboutImage: {
        url: "assets/Speciality-Images/Enhanced-Security.webp",
        alt: "Enhanced Security",
      },
      aboutTitle: { title: `Enhanced Security`, highlightedTitle: "" },
      aboutDescription: (
        <>
          With industry-standard encryption and a robust fraud prevention system, we ensure your transactions remain safe and trustworthy.
        </>
      ),
      flexReverse: "false",
    },
    {
      aboutImage: {
        url: "assets/Speciality-Images/Multiple-Payment-Options.webp",
        alt: "Multiple Payment Options",
      },
      aboutTitle: { title: `Multiple Payment Options`, highlightedTitle: "" },
      aboutDescription: (
        <>
          Offer your customers the flexibility they deserve. Accept online payments via credit cards, digital wallets, or even cash-on-delivery, catering to diverse preferences.
        </>
      ),
      flexReverse: "true",
    },
    {
      aboutImage: {
        url: "assets/Speciality-Images/Smooth-User-Experience.webp",
        alt: "Smooth User Experience",
      },
      aboutTitle: { title: `Smooth User Experience`, highlightedTitle: "" },
      aboutDescription: (
        <>
          Improve conversion rates and reduce cart abandonment with quick, intuitive, and error-free online payment processing systems.
        </>
      ),
      flexReverse: "false",
    },
    {
      aboutImage: {
        url: "assets/Speciality-Images/Global-Scalability.webp",
        alt: "Global Scalability",
      },
      aboutTitle: { title: `Global Scalability`, highlightedTitle: "" },
      aboutDescription: (
        <>
          Expanding to new regions? Our payment gateway solutions grow with your business while ensuring compliance with regional laws.
        </>
      ),
      flexReverse: "true",
    },
    {
      aboutImage: {
        url: "assets/Speciality-Images/Reporting-and-Analytics.webp",
        alt: "Reporting and Analytics",
      },
      aboutTitle: { title: `Reporting and Analytics`, highlightedTitle: "" },
      aboutDescription: (
        <>
          Access detailed transaction data with payment tracking software to manage payments efficiently and track your revenue growth.
        </>
      ),
      flexReverse: "false",
    },
  ];

  const featurePoints = [
    <>Integration with multiple payment providers, including Stripe integration services and PayPal.</>,
    <>Support for recurring payment setups and one-time transactions.</>,
    <>Currency conversion for international customers.</>,
    <>Real-time payment tracking software and detailed reporting tools.</>,
  ];

  const finalThoughts = [
    {heading: `Ready to Optimize Your Online Payments?`},
    {subText: `Let Ninjas Code simplify your payment gateway integration so you can focus on growing your business. Contact us today to get started!`},
  ]

  return (
    <div>
       <MetaTags
     title="Secure & Flexible Payment Gateway Solution for Your Business"
     description="Secure and reliable payment gateway management with Ninjas Code. Flexible integrations and detailed analytics to optimize transactions for your business."
     />
      <SpecialitiesBanner content={bannerContent} />

      <div className={styles.specialitiesAbout}>
        <div className={styles.container}>
          <h2>Why Choose Us For Your Payment Gateways?</h2>
          <ImageWithText aboutContent={specialityAbout} />
        </div>
      </div>

      <SpecialityFeatures features={featurePoints} />

      <TextOnly 
      content={finalThoughts}
      width
      />
    </div>
  );
};

export default PaymentGatewaysMgt;
